var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sentinel-indicators"},_vm._l((_vm.indicators),function(indicator){return _c('div',{staticClass:"indicator"},[_c('v-icon',[_vm._v(_vm._s(_vm.getImageByIndicator(indicator?.indicator)))]),_c('span',{staticClass:"text ml-1"},[_vm._v(_vm._s(indicator?.indicator))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }